import { twig } from 'twig';

import App from '../../assets/js/app';
import ScrollController from '../../assets/js/controllers/scroll';

import { parseHydration } from '../../assets/js/helpers';

import assetTemplate from '../../bits/asset/template.twig';
import gridNewsFilterTemplate from './filter.twig';
import gridNewsItemTemplate from './item.twig';

export default class GridNews {

	static selector = 'grid-news';

	el = {};

	categories = {};

	active = 'all';

	constructor(container) {
		this.el = {
			container,
			categories: container.querySelector(`.${this.constructor.selector}__filters ul`),
			list: container.querySelector(`.${this.constructor.selector}__listing`),
		};

		this.data = parseHydration(container);
		this.length = this.data.length;

		this.top = this.el.container.getBoundingClientRect().top - 200;

		this.mapCategories();
		this.renderCategories();
		this.renderItems();

		this.el.filters = container.querySelectorAll(`.${this.constructor.selector}__filters li`);

		this.addEventListeners();
	}

	addEventListeners() {
		for (const filter of this.el.filters) {
			filter.addEventListener('click', this.#onFilterClick);
		}
	}

	removeEventListeners() {
		for (const filter of this.el.filters) {
			filter.removeEventListener('click', this.#onFilterClick);
		}
	}

	#onFilterClick = (e) => {
		e.preventDefault();
		const { currentTarget } = e;
		const wasActive = this.el.container.querySelector(`.${this.constructor.selector}__filters li.is-active`);

		if (wasActive === currentTarget) return;

		this.clearList();

		if (wasActive) wasActive.classList.remove('is-active');
		currentTarget.classList.add('is-active');

		this.active = currentTarget.children[0].dataset.value;

		this.renderItems();

		ScrollController.adjust();
		// ScrollController.scrollTo(this.top, false);
	}

	clearList() {
		App.destroy(this.el.list);
		this.el.list.innerHTML = '';
	}

	mapCategories() {
		this.categories = {};
		for (let i = 0, l = this.length; i < l; ++i) {
			for (const category of this.data[i].categoriesNews) {
				if (!this.categories[category.slug]) {
					this.categories[category.slug] = {
						title: category.title,
						items: [i]
					};
				} else {
					this.categories[category.slug].items.push(i);
				}
			}
		}
	}

	renderItems() {
		let row;
		for (let i = 0; i < this.data.length; ++i) {
			const item = this.active !== 'all' ? this.data[this.categories[this.active].items[i]] : this.data[i];

			if (item) {
				item.image = twig({ data: assetTemplate }).render(item.assetFeatured.length ? item.assetFeatured[0] : { width: 495, height: 742 });
				item.index = i;

				const newItem = document.createElement('div');
				newItem.classList.add('grid-news__item');
				newItem.innerHTML = twig({ data: gridNewsItemTemplate }).render(item);

				if (i % 2 === 0) {
					row = document.createElement('div');
					row.classList.add('row');
					this.el.list.appendChild(row);
				}

				if (row) {
					row.appendChild(newItem);
				}
			}
		}

		App.apply(this.el.list, this.uri);
		App.refresh(true);
	}

	renderCategories() {
		this.el.categories.innerHTML = '';
		const all = document.createElement('li');
		all.classList.add('is-active');
		all.innerHTML = twig({ data: gridNewsFilterTemplate }).render({ value: 'all', label: 'All News' });
		this.el.categories.appendChild(all);
		for (const slug in this.categories) {
			const li = document.createElement('li');
			li.innerHTML = twig({ data: gridNewsFilterTemplate }).render({ value: slug, label: this.categories[slug].title });
			this.el.categories.appendChild(li);
		}
	}

	destroy() {
		this.removeEventListeners();
	}

}
